import { Routes, Route, Navigate } from "react-router-dom";
import { PublicRoute } from "./PublicRoute";
import { ProtectedRoute } from "./ProtectedRoute";
import { LifeguardLoginRoute } from "./LifeguardLoginRoute";
import { ROUTES } from "./routes";
import { RoleEnum } from "../api/client/types/user.types";
import { LifeguardPreLoginPage } from "../features/auth/pages/LifeguardPreLoginPage/LifeguardPreLoginPage";
import { LifeguardLoginPage } from "../features/auth/pages/LifeguardLoginPage/LifeguardLoginPage";
import { AdminLoginPage } from "../features/auth/pages/AdminLoginPage/AdminLoginPage";
import { LifeguardDataAgreementPage } from "../features/auth/pages/LifeguardDataAgreementPage/LifeguardDataAgreementPage";
import { LifeguardDashboardPage } from "../features/dashboard/pages/LifeguardDashboardPage/LifeguardDashboardPage";
import { AdminDashboardPage } from "../features/dashboard/pages/AdminDashboardPage/AdminDashboardPage";
import { RegisterSwimmerPage } from "../features/swimmers/pages/RegisterSwimmerPage/RegisterSwimmerPage";
import { EditSwimmerPage } from "../features/swimmers/pages/EditSwimmerPage/EditSwimmerPage";
import { DeleteSwimmersPage } from "../features/swimmers/pages/DeleteSwimmerPage/DeleteSwimmersPage";
import { RegisterNewPage } from "../features/news/pages/RegisterNewPage/RegisterNewPage";
import { NewDetailPage } from "../features/news/pages/NewDetailPage/NewDetailPage";
import { EditNewPage } from "../features/news/pages/EditNewPage/EditNewPage";
import { ReportsPage } from "../features/reports/pages/ReportsPage/ReportsPage";

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<PublicRoute />}>
        {/* Default redirect */}
        <Route
          index
          element={<Navigate to={ROUTES.PRE_LOGIN.LIFEGUARD} replace />}
        />

        <Route
          path={ROUTES.PRE_LOGIN.LIFEGUARD.replace("/", "")}
          element={<LifeguardPreLoginPage />}
        />

        <Route
          path={ROUTES.LOGIN.ADMINISTRATOR.replace("/", "")}
          element={<AdminLoginPage />}
        />
      </Route>

      {/* Administrator protected routes */}
      <Route
        path="/administrador"
        element={<ProtectedRoute role={RoleEnum.ADMINISTRATOR} />}
      >
        <Route path="dashboard" element={<AdminDashboardPage />} />
        <Route path="reportes" element={<ReportsPage />} />
        <Route path="novedades/:newId/editar" element={<EditNewPage />} />
        <Route path="banistas/:swimmerId/editar" element={<EditSwimmerPage />} />
        <Route path="banistas/:swimmerId/eliminar" element={<DeleteSwimmersPage />} />
      </Route>

      {/* Lifeguard login and agreement routes (special handling for pre-authenticated state) */}
      <Route path="/salvavidas" element={<LifeguardLoginRoute />}>
        <Route index element={<Navigate to={ROUTES.AGREEMENT.LIFEGUARD} replace />} />
        <Route path="acuerdo-de-datos" element={<LifeguardDataAgreementPage />} />
        <Route path="login" element={<LifeguardLoginPage />} />
      </Route>

      {/* Lifeguard protected routes (dashboard, etc.) - requires full authentication */}
      <Route
        path="/salvavidas"
        element={<ProtectedRoute role={RoleEnum.LIFEGUARD} />}
      >
        <Route path="dashboard" element={<LifeguardDashboardPage />} />
        <Route path="banistas/registrar" element={<RegisterSwimmerPage />} />
        <Route
          path="banistas/registrar/:swimmerId"
          element={<RegisterSwimmerPage />}
        />
        <Route path="novedades/registrar" element={<RegisterNewPage />} />
        <Route path="novedades/registrar/:swimmerId" element={<RegisterNewPage />} />
        <Route path="novedades/:newId" element={<NewDetailPage />} />
        <Route path="banistas/:swimmerId/editar" element={<EditSwimmerPage />} />
      </Route>

      {/* Fallback for unknown routes */}
      <Route
        path="*"
        element={<Navigate to={ROUTES.PRE_LOGIN.LIFEGUARD} replace />}
      />
    </Routes>
  );
};
